<circ-top-bar (toggleClick)="toggle()"></circ-top-bar>
<circ-nav [(expanded)]="expanded" [drawerMode]="drawerMode" [isAdmin]="isAdmin$ | async" (navClick)="navigationEventHandler($event)">
  <main class="content-wrapper col">
    <ng-content></ng-content>
  </main>
</circ-nav>
